export default "__VITE_ASSET__$AzXx6iH__"